import TicketConsultService from './../../services/ticket-consult.service'
import { Creators as SiteCreators } from '../site/site'

const initialState = {
	orderId: '',
	ticketsGoing: [],
	ticketsReturn: []
}

const prefix = 'ticket-consult/'
const Types = {
	LOAD: prefix + 'LOAD',
	SET_DATA: prefix + 'SET_DATA'
}

const setData = (orderId, ticketsGoing, ticketsReturn) => ({
	type: Types.SET_DATA,
	payload: { orderId, ticketsGoing, ticketsReturn }
})

const load = orderId => (dispatch, getState) => {
	const { ticketConsult } = getState()
	if (ticketConsult.orderId == orderId) {
		return Promise.resolve()
	}

	dispatch(SiteCreators.showLoading())

	return TicketConsultService.consultTickets(orderId).then(({ data }) => {
		const { ticketSaleGoing, ticketSaleReturn } = data
		dispatch(SiteCreators.hideLoading())
		dispatch(setData(orderId, ticketSaleGoing, ticketSaleReturn))
	})
}

export const Creators = {
	load,
	setData
}

export default function reducer(state = initialState, action) {
	switch (action.type) {
		case Types.SET_DATA:
			const { orderId, ticketsGoing, ticketsReturn } = action.payload
			return {
				...state,
				orderId,
				ticketsGoing,
				ticketsReturn,
				loading: false
			}
		default:
			return state
	}
}
